module.exports = __webpack_public_path__ + "static/media/cto-logo-bug.94627fb9.png";